import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { abreviarNome, formatToDate } from '../Components/jwtUtils';

// Evita hifenização no meio de palavras (ex.: "sat-isfatório") no PDF
Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4',
        padding: 1,
    },
    diploma: {
        position: 'relative',
        padding: 1,
        margin: 10,
        flex: 1,
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
    },
    message: {
        fontFamily: 'Helvetica',
        fontSize: 18,
        textAlign: 'left',
        marginTop: 220,
        marginLeft: 110,
        marginRight: 52,
        width: 620,
        color: '#000000',
        lineHeight: 1.5,
    },
    messageBold: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 18,
        color: '#000000',
    },
    signatureRow: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginTop: 86,
        marginLeft: 52,
        marginRight: 52,
        paddingHorizontal: 0,
    },
    signatureBlock: {
        width: '28%',
        alignItems: 'center',
        marginRight: 60,
        marginLeft: 30,
    },
    signatureLine: {
        borderBottomWidth: 1,
        borderBottomColor: '#000000',
        width: '100%',
        height: 2,
    },
    signatureLabel: {
        fontFamily: 'Helvetica',
        fontSize: 12,
        color: '#000000',
        textAlign: 'center',
    },
    signatureLabelItalic: {
        fontFamily: 'Helvetica',
        fontSize: 10,
        color: '#000000',
        textAlign: 'center',
        marginTop: 2,
    },
    footerRow: {
        position: 'absolute',
        bottom: 5,
        left: 0,
        right: 200,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    footerCenter: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 12,
        color: '#000000',
        textAlign: 'center',
        flex: 1,
    },
    footerCodigo: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 14,
        color: '#000000',
        textAlign: 'center',
        position: 'absolute',
        bottom: 5,
        right: 12,
        width: 90,
    },
});

const GerarCertificado = ({ data, diplomaUrl, empresa }) => {

    if (!data) return null;

    const diplomaImage = diplomaUrl || "../../assets/diploma.png";
    const imgFrente = data.certificado_frente && process.env.REACT_APP_IMG_URL
        ? `${process.env.REACT_APP_IMG_URL}/${data.certificado_frente}`
        : diplomaImage;
    const dataEmissao = data.data ? formatToDate(data.data) : '—';
    const prazoTexto = data.prazo_validade !== undefined && data.prazo_validade !== null
        ? `${data.prazo_validade} ${data.prazo_validade === 1 ? 'mês' : 'meses'}`
        : '—';
    const temVerso = data.certificado && process.env.REACT_APP_IMG_URL;
    const imgVerso = temVerso ? `${process.env.REACT_APP_IMG_URL}/${data.certificado}` : null;

    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>
                <View style={styles.diploma}>
                    <Image style={styles.backgroundImage} src={imgFrente} />
                    <Text style={styles.message}>
                        Certificamos que <Text style={styles.messageBold}>{data.nomeAluno}</Text>, identificado (a) com o CPF <Text style={styles.messageBold}>{data.codigo || '—'}</Text> concluiu com aproveitamento satisfatório o Treinamento de <Text style={styles.messageBold}>{data.nomeCurso}</Text>, com carga horária de <Text style={styles.messageBold}>{data.cargaHorariaTotal} {Number(data.cargaHorariaTotal) === 1 ? 'hora' : 'horas'}</Text>, promovido nas dependências da {empresa}.
                    </Text>

                    <View style={styles.signatureRow}>
                        <View style={styles.signatureBlock}>
                            <Text style={styles.signatureLabel}></Text>
                            <Text style={styles.signatureLabel}></Text>
                            <Text style={styles.signatureLabel}></Text>
                        </View>
                        <View style={styles.signatureBlock}>
                            <Text style={styles.signatureLabel}>{data.nomeAluno ? abreviarNome(data.nomeAluno) : '—'}</Text>
                            <View style={styles.signatureLine} />
                            <Text style={styles.signatureLabelItalic}>Participante</Text>
                        </View>
                    </View>

                    <View style={styles.footerRow}>
                        <View style={{ width: 100 }} />
                        <Text style={styles.footerCenter}>
                            CERTIFICADO EMITIDO: {dataEmissao}   PRAZO DE VALIDADE: {prazoTexto}
                        </Text>
                    </View>

                    <Text style={styles.footerCodigo}>{data.id}</Text>
                </View>
            </Page>
            {imgVerso && (
                <Page size="A4" orientation="landscape" style={styles.page}>
                    <View style={styles.diploma}>
                        <Image style={styles.backgroundImage} src={imgVerso} />
                    </View>
                </Page>
            )}
        </Document>
    )
};

export default GerarCertificado;
